<div class="flex h-full flex-col gap-4" *transloco="let t">
  <div>
    <ITabs [tabs]="inventoryTypeTabs" />
  </div>
  <p class="type-body">{{ t("dsp-blacklist.scope_description") }}</p>
  <router-outlet />
</div>
